import React from 'react';
import CreateNonPayableBenefits from './CreateNonPayableBenefitsForm';

const CreateNonPayableBenefitsView = () => {
  return <CreateNonPayableBenefits />;
};

export default CreateNonPayableBenefitsView;
